import {TimelineLite, TweenLite} from "gsap";
import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {PearlHarborGameMode} from "../../server/PearlHarborGameMode";
import {PearlHarbor} from "../../PearlHarbor";
import {PearlHarborHelper} from "../../utils/PearlHarborHelper";
import {PearlHarborWinConfigs} from "../../configs/PearlHarborWinConfigs";

export class PearlHarborTotalWinRunner implements SimplePresentationRunner {

    private _totalBetWays: number = 0;
    private _isFinished: boolean = false;
    private _mainTL: TimelineMax;
    private _controller: SimplePresentationRunnerController;

    private static skip(): void {
        PearlHarbor.totalWinView.hardAbort();
    }

    public shouldRun(): boolean {
        if (PearlHarbor.model.gameData.brokeBank) {
            return false;
        }

        const isCloseGameRound: boolean = (PearlHarbor.model.gameData.nextMode === PearlHarborGameMode.NORMAL || PearlHarbor.model.gameData.freespinTriggeredThisSpin);

        if (!isCloseGameRound || (PearlHarbor.model.gameData.accumulatedRoundWin === 0)) {
            return false;
        }

        const isInFs: boolean = PearlHarborHelper.isFreeSpin(PearlHarbor.model.gameData.mode) && (PearlHarbor.model.gameData.nextMode === PearlHarborGameMode.NORMAL);
        if (isInFs) {
            return false;
        }

        if(PearlHarborWinConfigs.getBigWinLevels(PearlHarbor.model.winRatio).length > 0){
            return false;
        }

        this._totalBetWays += PearlHarbor.model.gameData.betClusterWins.length;
        return true;
    }

    public start(controller: SimplePresentationRunnerController): void {
        this._isFinished = false;
        for (let i: number = 0; i < PearlHarbor.allReelsView.mainReelModels.length; i++) {
            (PearlHarbor.allReelsView.mainReelModels[i].reelView.stopSymbolIdleAnimation());
        }
        this._controller = controller;
        this._mainTL = new TimelineLite();
        this._mainTL.add([
            PearlHarbor.totalWinView.getTotalWinTimeline(PearlHarbor.model.gameData.accumulatedRoundWin, PearlHarbor.model.gameData.waysWonTotalRound, () => this.complete()),
            this._mainTL.add(() => this._controller.setSkipCallback(() => PearlHarborTotalWinRunner.skip()))
        ]);

        if (this._mainTL.duration() == 0) {
            this._mainTL.add(TweenLite.to(this, {duration: 0.001}));
        }
    }

    private complete(): void {
        if(this._isFinished){
            return;
        }
        this._isFinished = true;
        this._totalBetWays = 0;
        this._controller.finish();
    }
}